<template lang="js">
<div class="setting-toggle">
    <input class="setting-option" type="radio" v-bind:value="bindValue" id="option" v-model="itemValue" />
    <label class="option-name" >{{ option }}</label>
</div>
</template>
<script>

import { settingStore } from '@/js/store/settingStore';

export default {
    name: "SettingItemToggle",
    data: function () {
        return {
            itemValue: 0,
            settingStore
        }
    },
    watch: {
        itemValue: {
            handler: function () {
                settingStore[this.$props.watchValue] = this.itemValue;
            }
        }
    },
    props: {
        watchValue: String,
        bindValue: Number,
        option: String,
    },
    mounted: function () {
        this.$watch(`settingStore.${this.$props.watchValue}`, () => {
            this.itemValue = settingStore[this.$props.watchValue];
        })
    }
}
</script>
<style lang="css" scoped>
.setting-toggle {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    transform: translateY(6px);
}

.setting-option {
    appearance: none;
    outline: none;
    background: url("../../assets/art/setting/checkbox1.png");
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 0;
    margin-right: 10px;
    height: 30px;
    width: 30px;
}

.setting-option:checked {
    appearance: none;
    outline: none;
    background: url("../../assets/art/setting/checkbox2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 0;
    margin-right: 10px;
}

.option-name {
    line-height: 30px;
    font-weight: bold;
    font-size: 16pt;
}
</style>